import { isIOS } from "../../utils/common";

export function getOrderTypeName(orderType: number) {
  let orderTypeText = "";
  switch (orderType) {
    case 1:
      orderTypeText = "维修";
      break;
    case 2:
      orderTypeText = "保养";
      break;
    case 3:
      orderTypeText = "维修加保养";
      break;
    default:
      break;
  }
  return orderTypeText;
}

export function throttle(func: Function, limit: number) {
  let inThrottle: boolean;

  return function (this: any): any {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      inThrottle = true;
      func.apply(context, args);
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

/**
 * ios 解决页面返回不刷新问题
 */
export function refreshPageByBack() {
  if (isIOS()) {
    let isPageHide = false;
    console.log("------> page <--------");
    window.addEventListener("pageshow", function () {
      if (isPageHide) {
        console.log("------> pageshow <------");
        window.location.reload();
      }
    });
    window.addEventListener("pagehide", function () {
      console.log("------> pagehide <------");
      isPageHide = true;
    });
  }
}

